import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import BatchForm from '@/components/BatchForm';

const AddBatchPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <Button variant="outline" size="sm" asChild>
          <Link to="/settings/batches">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Batches
          </Link>
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">Add New Batch</h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Create Batch</CardTitle>
        </CardHeader>
        <CardContent>
          <BatchForm />
        </CardContent>
      </Card>
    </div>
  );
};

export default AddBatchPage;
